const translations = {
    associatedApplicationDate: 'Associated Application Date',
    back: 'Back',
    fileType: 'File Types',
    fileUploads: 'File Uploads',
    saveToFlightLog: 'Save to Flight Log',
    swathWidth: 'Swath Width',
    swathWidthFormDescription:
        'We have detected that some of your files do not contain the swath width information.' +
        ' Please either provide the swath width in meters that was used or select the checkbox to use the ' +
        'configured swath width for each drone defined in your equipment settings.',
    swathWidthFormTitle: 'Swath Width Info',
    unknownError: 'Unknown error processing your flight logs try again later.',
    useDroneSwathWidth: 'Use configured drone swath width'
};

export default translations;
